module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-marquee-1-image-1-1-32672a7e0922ea0e0369d535d45b564b.png";